<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <!-- Header -->
    <Header
      title="Statistics"
      :showGoBack="true"
    />

    <!-- Main content -->
    <main
      class="scrollable container"
      :style="{paddingTop: '10px'}"
      v-if="!statisticsLoading"
    >
      <!-- Categories -->
      <section :style="{marginBottom: '30px'}">
        <ul
          class="row-center"
          :style="{
            padding: '2px',
            borderRadius: '5px',
            backgroundColor: '#FFF6F2',
          }"
        >
          <li
            v-for="category in categories"
            :key="category"
            :style="{
              height: '28px',
              width: '100%',
              borderRadius: '5px',
              backgroundColor:
                category === selectedCategory
                  ? 'var(--main-dark)'
                  : 'transparent',
            }"
            @click="selectedCategory = category"
            class="center clickable"
          >
            <span
              class="t14"
              :style="{
                color:
                  category === selectedCategory
                    ? 'var(--white-color)'
                    : 'var(--main-dark)',
              }"
              >{{ category }}</span
            >
          </li>
        </ul>
      </section>

      <!-- Card details -->
      <section :style="{marginBottom: '30px'}">
        <div
          class="row-center"
          :style="{gap: '10px', marginBottom: '14px'}"
        >
          <span
            class="t14"
            :style="{marginTop: '1px'}"
            >Sep 1 - Sep 20, 2022</span
          >
          <CalendarSvg />
        </div>
        <div
          :style="{
            padding: '12px 20px 12px 12px',
            borderRadius: '10px',
            border: '1px solid #FFEFE6',
          }"
          class="row-center clickable"
        >
          <img
            alt="chart"
            src="../assets/cards/01.jpg"
            :style="{width: '62px', height: 'auto', marginRight: '12px'}"
          />
          <div
            :style="{
              marginRight: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }"
          >
            <span class="t12">**** **** **** 7895</span>
            <h6>4 863.27 USD</h6>
          </div>
          <MoreVerticalSvg />
        </div>
      </section>

      <!-- Chart -->
      <section :style="{marginBottom: '30px'}">
        <div
          :style="{
            border: '1px solid #FFEFE6',
            padding: '20px',
            borderRadius: '14px',
            position: 'relative',
          }"
        >
          <!-- Diagram -->
          <ul
            :style="{
              width: '78%',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
            }"
          >
            <li
              v-for="element in diagramElements"
              :key="element"
              :style="{
                width: '100%',
                height: element.height,
                borderRadius: '3px',
                backgroundColor: element.color,
                marginRight: '10px',
              }"
            ></li>
            <div
              :style="{
                position: 'absolute',
                bottom: '0',
                right: '0',
                padding: '20px 20px 13px 0',
              }"
            >
              <span
                class="t16"
                :style="{
                  color: 'var(--main-dark)',
                }"
                >USD</span
              >
            </div>
            <div
              :style="{
                position: 'absolute',
                top: '0',
                right: '0',
                padding: '20px 20px 13px 0',
              }"
            >
              <span
                :style="{
                  fontSize: '32px',
                }"
                >- 11 654<span :style="{fontSize: '20px'}">.24</span>
              </span>
            </div>
          </ul>
        </div>
      </section>

      <!-- statistics -->
      <section>
        <ul>
          <li
            v-for="statistic in statistics"
            :key="statistic.id"
            :style="{
              padding: '10px',
              borderRadius: '10px',
              backgroundColor: '#FFF7F2',
              marginBottom: index === statistics.length - 1 ? '0' : '6px',
            }"
            class="row-center"
            @click="$router.push(routes.TRANSACTION_DETAILS)"
          >
            <img
              :src="statistic.icon"
              alt="icon"
              :style="{width: '40px', height: '40px', marginRight: '14px'}"
            />
            <div :style="{marginRight: 'auto'}">
              <h6>
                {{ statistic.name }}
              </h6>
              <span class="t12"
                >{{ statistic.transactionsQty }} transactions</span
              >
            </div>
            <div
              :style="{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }"
            >
              <h6>- {{ statistic.amount }}</h6>
              <span class="t12">{{ statistic.inPercent }}%</span>
            </div>
          </li>
        </ul>
      </section>
    </main>

    <!-- Loader -->
    <Loader v-if="statisticsLoading" />
  </div>
</template>

<script setup>
import {ref} from 'vue';

import {Header} from '@/components';
import {Loader} from '@/components';

import {CalendarSvg} from '@/assets/svg';
import {MoreVerticalSvg} from '@/assets/svg';

import {routes} from '@/routes';
import {useOpacity} from '@/hooks';
const opacity = useOpacity();

const categories = ['Income', 'Expenses'];
const diagramElements = [
  {
    id: 1,
    color: '#040325',
    height: '126px',
  },
  {
    id: 2,
    title: 'Expenses',
    color: '#4F4F66',
    height: '95px',
  },
  {
    id: 3,
    title: 'Expenses',
    color: '#818192',
    height: '51px',
  },
  {
    id: 4,
    title: 'Expenses',
    color: '#B4B3BE',
    height: '37px',
  },
  {
    id: 5,
    title: 'Expenses',
    color: '#CDCDD3',
    height: '8px',
  },
];

const selectedCategory = ref(categories[0]);

import {useGetStatistics} from '@/hooks';

const {statistics, statisticsLoading} = useGetStatistics();
</script>
